import { render } from "./EbookCard.vue?vue&type=template&id=2bf58d4e&scoped=true"
import script from "./EbookCard.vue?vue&type=script&lang=js"
export * from "./EbookCard.vue?vue&type=script&lang=js"

import "./EbookCard.vue?vue&type=style&index=0&id=2bf58d4e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf58d4e"]])

export default __exports__